require('styles/common/util.scss');
require('styles/common/common1.scss');
require('plugins/Font-Awesome/css/all.min.css');
require('plugins/flexslider/flexslider.css');
require('plugins/slide/index.css');
require('plugins/slide/slide.css');
require('plugins/slick-carousel/slick/slick.css');
require('plugins/swiper/dist/css/swiper.min.css');
require('styles/pages/baike_one.scss');

require('script!jquery');
require('../common/form-validation.coffee');
require('script!sweetAlert');
require('script!ajaxform');
require('script!affix');
require('script!flexslider');
require('script!plugins/slide/slide.min.js');
require('script!plugins/swiper/dist/js/swiper.jquery.js');
require('../common/city.coffee');
require('../common/select2.js');

// var oTop = $(".baike_one_left").offset().top;
//获取导航栏的高度，此高度用于保证内容的平滑过渡
var headTop = $('.baike_one_all').offset().top;
var barHeight = $('.baike_one_left').height();
var footTOP = $('#page-footer').offset().top;
// 监听页面的滚动
$(window).scroll(function () {
  "use strict";
  var sTop = $(this).scrollTop();
  // console.log(footTOP - barHeight - 135 < sTop);
  if (footTOP - barHeight - 135 < sTop) {
    $(".baike_one_left").css({"top": 'auto', "bottom": '135px'});
  } else {
    var barTop = sTop - headTop > 0 ? sTop - headTop + 20 : 0;
    $(".baike_one_left").css({"top": barTop + 'px', "bottom": 'auto'});
  }
});

new Swiper('.middle_lunbo .swiper-container',{
  prevButton: '.swiper-button-prev',
  nextButton: '.swiper-button-next',
  keyboard: true,
  autoplay: 1500,
  speed: 1000,
  loop: true,
  autoplayDisableOnInteraction: false,
  // effect : 'fade',
  // fade: {
  //   crossFade: false,
  // },
  pagination: '.swiper-pagination',
  paginationType: 'fraction'
});

$(".city_select2").select2({
  placeholder: "请选择您装修房屋所在城市",
  allowClear: true
});





// 表单
$(function() {
  "use strict";

  var $forms = $("main form");
  $forms.each(function(inde, form) {
    var $form = $(form);

    $form.validate({
      errorPlacement: function(error) {
        return swal({
          title: error[0].innerHTML,
          allowOutsideClick: false
        });
      },
      submitHandler: function(form) {
        var phoneNumber, userId;
        phoneNumber = form.elements.mobile.value.trim();
        userId = "MOBI" + phoneNumber + "}";

        $(form).ajaxSubmit({
          dataType: "json",
          data: {
            rnd: parseInt(Math.random() * 1e7, 10) + new Date().getTime()
          },
          error: function() {
            return swal({
              title: "对不起，出错了，请稍后重试！",
              allowOutsideClick: true
            });
          },
          success: function(res) {
            if (res.msg && res.msg[0] && res.msg[0].type === "success") {
              swal({
                type: "success",
                title: '预约成功，稍后会有家装顾问与您联系，请注意电话',
                allowOutsideClick: true
              });
              // swal({
              //   customClass: "alert-success",
              //   title:
              //     '<img class="form_success" src="' +
              //     $("#alertImg").attr("src") +
              //     '" alt="">',
              //   confirmButtonText: "返  回",
              //   confirmButtonColor: "#3b9bff",
              //   allowOutsideClick: true,
              //   html: true
              // });
            }
            if (res.msg[0].type === "error") {
              swal({
                title: res.msg[0].info,
                allowOutsideClick: true
              });
              return false;
            }
            if (res.msg[0].type === "error") {
              swal({
                title: res.msg[0].info,
                allowOutsideClick: true
              });
              return false;
            }
          }
        });
      }
    });

    var elements = form.elements;
    // var effectives = [];

    for (var i = 0; i < elements.length; i++) {
      var element = elements[i];
      var name = $(element).attr("name");
      if (name) {
        // effectives.push(element);
        var $elm = $(element);
        $elm.rules("add", {
          // required: Boolean($elm.attr('required')),
          mobileNum: Boolean($elm.attr("mobile")),
          messages: {
            required: $elm.data("required"),
            mobileNum: $elm.data("mobile")
          }
        });
      }
    }
  });
});


/*****************
 ** WEBPACK FOOTER
 ** ./baike_one.js
 ** module id = 0
 ** module chunks = 43
 **/